var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1734 3.92896H19.6484C19.9137 3.92896 20.168 4.03431 20.3555 4.22185C20.5431 4.40938 20.6484 4.66374 20.6484 4.92896V21.429C20.6484 21.6942 20.5431 21.9485 20.3555 22.1361C20.168 22.3236 19.9137 22.429 19.6484 22.429H5.64844C5.38322 22.429 5.12887 22.3236 4.94133 22.1361C4.75379 21.9485 4.64844 21.6942 4.64844 21.429V4.92896C4.64844 4.66374 4.75379 4.40938 4.94133 4.22185C5.12887 4.03431 5.38322 3.92896 5.64844 3.92896H9.14844V5.42896H16.1484V3.92896H17.1734Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 9.92896L10.1484 13.9295H15.1504L11.1484 17.9295M9.14844 2.42896H16.1484V5.42896H9.14844V2.42896Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.0c4b6578dcd5bbf8b6673f2a8ac8bd98.svg";
export { ForwardRef as ReactComponent };